module.exports = __webpack_public_path__ + "static/img/brouns.1acc8b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/brouns.png
// module id = 8pCr
// module chunks = 1